const CLEAR_SUBMISSION_ITEM = (state) => {
  state.submissionItem = {};
  state.submissionErrors = [];
};

export default CLEAR_SUBMISSION_ITEM;
